import * as React from 'react';

export const LazyMaxRiskClassStep = React.lazy(() => import('./component'));
